"use client";

import { useMemo } from "react";

import { HomeDashboardTable } from "@/components/home-dashboard-table";
import { getHomeTopRecurringDonorsColumns } from "@/containers/home/homeTopRecurringDonorsColumns";
import { usePreloadDonor } from "@/hooks/useDonor";
import { useRecurringPlansStats } from "@/hooks/useRecurringPlansStats";

const DONOR_TABLE_ROW_LIMIT = 10;

export function RecurringDonorTables() {
  const { stats, isLoading } = useRecurringPlansStats();
  const topRecurringDonors = stats?.topRecurringDonors ?? [];

  const { preloadDonor } = usePreloadDonor();

  const columns = useMemo(
    () => getHomeTopRecurringDonorsColumns(preloadDonor),
    [preloadDonor],
  );

  const rows = topRecurringDonors.slice(0, DONOR_TABLE_ROW_LIMIT);

  return (
    <HomeDashboardTable
      title="Top recurring donors"
      viewAllHref="/recurring"
      columns={columns}
      data={rows}
      isLoading={isLoading}
      emptyMessage="No active regular plans yet"
      getRowId={(row) => String(row.id)}
    />
  );
}
